// Máscaras, conversões de valor e consultas externas (CEP/CNPJ) da Ficha de Cadastro.
import { mascararCnpj, limparCnpj } from "../../utils/documento";

export const toDate = (v) => (v ? String(v).substring(0, 10) : "");
export const fmtData = (v) => (v ? String(v).substring(0, 10).split("-").reverse().join("/") : "—");
export const toStr = (v) => (v == null ? "" : String(v));
export const toMoeda = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = parseFloat(String(v));
  return isNaN(n) ? "" : n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
export const maskMoeda = (raw) => {
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";
  const num = parseInt(digits, 10) / 100;
  return num.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
export const mascararCEP = (raw) =>
  String(raw)
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .substring(0, 9);

export const limitarAnoData = (value) => {
  if (!value) return value;
  const [ano, mes, dia] = value.split("-");
  return ano && ano.length > 4 ? `${ano.slice(0, 4)}-${mes || "01"}-${dia || "01"}` : value;
};

export async function buscarEnderecoPorCep(cep) {
  const apenasNumeros = String(cep).replace(/\D/g, "");
  if (apenasNumeros.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${apenasNumeros}/json/`);
    const data = await res.json();
    if (data.erro) return null;
    return { endereco: data.logradouro, bairro: data.bairro, cidade: data.localidade, uf: data.uf };
  } catch {
    return null;
  }
}
export const mascararTelefone = (raw) => {
  // Fixo (10 dígitos): (00) 0000-0000 · Celular (11 dígitos): (00) 00000-0000.
  const d = String(raw ?? "")
    .replace(/\D/g, "")
    .slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
export const mascararCelular = (raw) =>
  String(raw)
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .substring(0, 15);
export const mascararCPF = (raw) =>
  String(raw)
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    .substring(0, 14);
export const mascararRG = (raw) =>
  String(raw)
    .replace(/[^0-9Xx]/g, "")
    .toUpperCase()
    .substring(0, 9)
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})([\dX])$/, "$1-$2");
// CNPJ numérico ou alfanumérico (letras A-Z nas 12 primeiras posições).
export const mascararCNPJ = (raw) => mascararCnpj(raw);

// Consulta CNPJ na Receita Federal (via BrasilAPI/ReceitaWS, com fallback no backend) —
// mesma rotina já usada na tela de Proposta Comercial.
export async function buscarDadosCnpj(cnpjMascarado) {
  const digitos = limparCnpj(cnpjMascarado);
  if (digitos.length !== 14) return { ok: false, motivo: "invalido", mensagem: "" };

  const token = localStorage.getItem("token");
  try {
    const res = await fetch(`/api/proprietarios/consulta-documento?tipo=PJ&documento=${digitos}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const corpo = await res.json().catch(() => ({}));
    if (!res.ok) {
      const motivo = res.status === 404 ? "nao_encontrado" : res.status === 400 ? "invalido" : "servidor";
      return { ok: false, motivo, mensagem: corpo?.erro || "Erro ao consultar CNPJ." };
    }
    if (!corpo.nome) return { ok: false, motivo: "vazio", mensagem: "CNPJ localizado, porém sem razão social retornada." };
    return {
      ok: true,
      razaoSocial: corpo.nome,
      endereco: corpo.rua || "",
      numero: corpo.numero || "",
      bairro: corpo.bairro || "",
      cidade: corpo.cidade || "",
      uf: corpo.estado || "",
      cep: corpo.cep || "",
      complemento: corpo.complemento || "",
    };
  } catch (err) {
    console.error("Erro ao consultar CNPJ:", err);
    return { ok: false, motivo: "rede", mensagem: "Erro de conexão ao consultar CNPJ." };
  }
}

export function fichaParaForm(f) {
  return {
    tipoPessoa: f.tipoPessoa || "PF",
    campoProposta: f.campoProposta || "",
    // PJ dados
    razaoSocial: toStr(f.razaoSocial),
    cnpj: toStr(f.cnpj),
    // Estrangeiro (Locatário / Fiador estrangeiro)
    estrangeiro: Boolean(f.estrangeiro),
    documentoEstrangeiroTipo: toStr(f.documentoEstrangeiroTipo),
    documentoEstrangeiroNumero: toStr(f.documentoEstrangeiroNumero),
    documentoEstrangeiroPais: toStr(f.documentoEstrangeiroPais),
    cpf: toStr(f.cpf),
    email: toStr(f.email),
    objetoSocialPrincipal: toStr(f.objetoSocialPrincipal),
    outrosObjetosSociais: toStr(f.outrosObjetosSociais),

    // PJ endereço principal
    endereco: toStr(f.endereco),
    numero: toStr(f.numero),
    bairro: toStr(f.bairro),
    cidade: toStr(f.cidade),
    uf: toStr(f.uf),
    cep: toStr(f.cep),
    complemento: toStr(f.complemento),
    // PJ telefone
    telefone: toStr(f.telefone),
    celular: toStr(f.celular),
    // PJ empresarial
    dataConstituicao: toDate(f.dataConstituicao),
    capitalSocial: toMoeda(f.capitalSocial),
    // PJ filial
    enderecoFilial: toStr(f.enderecoFilial),
    numeroFilial: toStr(f.numeroFilial),
    bairroFilial: toStr(f.bairroFilial),
    cidadeFilial: toStr(f.cidadeFilial),
    ufFilial: toStr(f.ufFilial),
    cepFilial: toStr(f.cepFilial),
    complementoFilial: toStr(f.complementoFilial),
    telefoneFilial: toStr(f.telefoneFilial),
    celularFilial: toStr(f.celularFilial),
    // PJ operacional
    ramoAtividade: toStr(f.ramoAtividade),
    produtosServicos: toStr(f.produtosServicos),
    qtdeFuncionarios: toStr(f.qtdeFuncionarios),
    faturamentoMensal: toMoeda(f.faturamentoMensal),

    // Observação geral da Ficha de Cadastro
    observacao: toStr(f.observacao),

    // Observação específica do Checklist de Documentos
    observacaoDocumental: toStr(f.observacaoDocumental),
    linkGoogleImovel: toStr(f.linkGoogleImovel),

    // PF dados pessoais
    pfNome: toStr(f.pfNome) || (f.tipoPessoa !== "PJ" ? toStr(f.razaoSocial) : ""),
    pfDtNascimento: toDate(f.pfDtNascimento),
    pfNacionalidade: toStr(f.pfNacionalidade),
    pfNaturalidade: toStr(f.pfNaturalidade),
    pfEstadoCivil: toStr(f.pfEstadoCivil),
    pfRegimeCasamento: toStr(f.pfRegimeCasamento),
    pfProfissao: toStr(f.pfProfissao),
    // PF documentos
    rg: toStr(f.rg),
    rgOrgao: toStr(f.rgOrgao),
    rgEmissao: toDate(f.rgEmissao),
    // PF endereço
    pfEndereco: toStr(f.pfEndereco),
    pfNumero: toStr(f.pfNumero),
    pfBairro: toStr(f.pfBairro),
    pfCidade: toStr(f.pfCidade),
    pfUf: toStr(f.pfUf),
    pfCep: toStr(f.pfCep),
    pfComplemento: toStr(f.pfComplemento),
    // PF contato
    pfTelefone: toStr(f.pfTelefone),
    pfCelular: toStr(f.pfCelular),
    pfEmail: toStr(f.pfEmail) || (f.tipoPessoa !== "PJ" ? toStr(f.email) : ""),
    // cônjuge
    pfConjuge: toStr(f.pfConjuge),
    pfConjugeDtNascimento: toDate(f.pfConjugeDtNascimento),
    pfConjugeNacionalidade: toStr(f.pfConjugeNacionalidade),
    pfConjugeNaturalidade: toStr(f.pfConjugeNaturalidade),
    pfConjugeProfissao: toStr(f.pfConjugeProfissao),
    conjugeCpf: toStr(f.conjugeCpf),
    conjugeRg: toStr(f.conjugeRg),
    conjugeRgOrgao: toStr(f.conjugeRgOrgao),
    conjugeRgEmissao: toDate(f.conjugeRgEmissao),
    conjugeTelefone: toStr(f.conjugeTelefone),
    conjugeCelular: toStr(f.conjugeCelular),
    conjugeEmail: toStr(f.conjugeEmail),
    // PF emprego
    pfEmpresaTrabalha: toStr(f.pfEmpresaTrabalha),
    pfEmpresaEndereco: toStr(f.pfEmpresaEndereco),
    pfEmpresaNumero: toStr(f.pfEmpresaNumero),
    pfEmpresaBairro: toStr(f.pfEmpresaBairro),
    pfEmpresaCidade: toStr(f.pfEmpresaCidade),
    pfEmpresaUf: toStr(f.pfEmpresaUf),
    pfEmpresaCep: toStr(f.pfEmpresaCep),
    pfEmpresaComplemento: toStr(f.pfEmpresaComplemento),
    pfEmpresaDtAdmissao: toDate(f.pfEmpresaDtAdmissao),
    pfEmpresaCargo: toStr(f.pfEmpresaCargo),
    pfEmpresaSalario: toMoeda(f.pfEmpresaSalario),
    pfEmpresaOutroRendimento: f.pfEmpresaOutroRendimento ?? null,
    pfEmpresaOutroRendimentoValor: toMoeda(f.pfEmpresaOutroRendimentoValor),
    pfEmpresaOutroRendimentoProvem: toStr(f.pfEmpresaOutroRendimentoProvem),
    // cônjuge emprego
    conjugePossuiRenda: f.conjugePossuiRenda ?? null,
    conjugeEmpresaTrabalha: toStr(f.conjugeEmpresaTrabalha),
    conjugeEmpresaEndereco: toStr(f.conjugeEmpresaEndereco),
    conjugeEmpresaNumero: toStr(f.conjugeEmpresaNumero),
    conjugeEmpresaBairro: toStr(f.conjugeEmpresaBairro),
    conjugeEmpresaCidade: toStr(f.conjugeEmpresaCidade),
    conjugeEmpresaUf: toStr(f.conjugeEmpresaUf),
    conjugeEmpresaCep: toStr(f.conjugeEmpresaCep),
    conjugeEmpresaComplemento: toStr(f.conjugeEmpresaComplemento),
    conjugeEmpresaDtAdmissao: toDate(f.conjugeEmpresaDtAdmissao),
    conjugeEmpresaCargo: toStr(f.conjugeEmpresaCargo),
    conjugeEmpresaSalario: toMoeda(f.conjugeEmpresaSalario),
    conjugeEmpresaOutroRendimento: f.conjugeEmpresaOutroRendimento ?? null,
    conjugeEmpresaOutroRendimentoValor: toMoeda(f.conjugeEmpresaOutroRendimentoValor),
    conjugeEmpresaOutroRendimentoProvem: toStr(f.conjugeEmpresaOutroRendimentoProvem),
  };
}
